import { EntryInterface, Entry } from "../store/Entry";

function toRaw(entry: EntryInterface): EntryInterface {
  const ret = {
    key: entry.key,
    type: entry.type,
    repeated: entry.repeated,
    note: entry.note,
    fields:
      entry.type == "RECORD" ? entry.fields.map((field) => toRaw(field)) : [],
  };
  if (entry.type != "RECORD") {
    // @ts-expect-error TS2790
    delete ret.fields;
  }
  return ret;
}

export function toJSON(entries: EntryInterface[]) {
  return JSON.stringify(
    entries.map((entry) => toRaw(entry)),
    undefined,
    "  ",
  );
}

export function fromJSON(json: string): EntryInterface[] {
  return JSON.parse(json) as EntryInterface[];
}

export function entriesToDefinition(entries: Entry[]) {
  return JSON.stringify(entries.map((entry) => toRaw(entry)));
}
